module.exports = __webpack_public_path__ + "static/pandesal-treats-a543b94337f27ff7b39989b36d9003fb.jpg";